import { buildTaxDisplayPolicy } from './taxDisplay'

export const buildCountryDisplayRules = (
  tenantCountryRegion,
  tenantTaxRegime
) => {
  const taxDisplay = buildTaxDisplayPolicy({
    countryRegion: tenantCountryRegion,
    taxRegime: tenantTaxRegime
  })
  const isUSCountry = taxDisplay.isUSSalesTaxRegime

  return {
    ...taxDisplay,
    isUSCountry,
    showTaxSuffix: taxDisplay.showTaxSuffix,
    showRrp: !isUSCountry,
    showGp: !isUSCountry,
    showApplicableTaxCodes: !taxDisplay.showTaxCodeSelector,
    showFreightHelp: !isUSCountry
  }
}
